import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import jwtService from 'app/services/jwtService';

const GENERIC_MESSAGE =
  'If an account exists for that email, we’ll send password reset instructions.';

const useStyles = makeStyles({
  container: {
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#f5f5f5',
    padding: '20px'
  },
  formBox: {
    width: '100%',
    maxWidth: '600px',
    background: 'white',
    padding: '30px',
    borderRadius: '12px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    '@media screen and (max-width: 500px)': {
      padding: '15px'
    }
  },
  title: {
    fontFamily: 'Arial, sans-serif',
    marginTop: 0,
    marginBottom: '16px'
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px'
  },
  message: {
    marginTop: '15px',
    color: '#1976d2',
    textAlign: 'center',
    fontFamily: 'Arial, sans-serif',
    fontSize: '12px',
  },
  errorMessage: {
    color: '#d32f2f'
  },
  backLink: {
    fontFamily: 'Arial, sans-serif',
    display: 'block',
    marginTop: '16px',
    textAlign: 'center',
    color: '#2f2f2f !important',
    fontSize: '14px !important',
    fontWeight: '600 !important',
    textTransform: 'capitalize !important',

    '&:hover': {
      color: '#2f2f2f !important',
    }
  }
});

function ForgotPassword() {
  const classes = useStyles();
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  async function handleSubmit(event) {
    event.preventDefault();
    setSubmitting(true);
    setErrorMessage(null);

    try {
      await jwtService.forgotPassword(email);
    } catch (error) {
      const data = error.response?.data;
      setErrorMessage(
        data?.error?.message || data?.errors?.[0]?.msg || 'We couldn’t send the reset link. Please try again later.'
      );
    } finally {
      setSubmitted(true);
      setSubmitting(false);
    }
  }

  return (
    <div className={classes.container}>
      <form className={classes.formBox} onSubmit={handleSubmit}>
        <h1 className={classes.title}>Forgot password</h1>
        <TextField
          fullWidth
          required
          className="mt-8 mb-16"
          id="email"
          name="email"
          label="Email"
          variant="outlined"
          type="email"
          value={email}
          onChange={event => setEmail(event.target.value)}
        />

        <div className={classes.buttonContainer}>
          <Button
            type="submit"
            disabled={submitting}
            className="whitespace-no-wrap normal-case"
            variant="contained"
            color="secondary"
          >
            Send reset link
          </Button>
        </div>

        {submitted && (
          <p className={errorMessage ? `${classes.message} ${classes.errorMessage}` : classes.message}>
            {errorMessage || GENERIC_MESSAGE}
          </p>
        )}

        <Link className={classes.backLink} to="/login">
          Back to sign in
        </Link>
      </form>
    </div>
  );
}

export default ForgotPassword;
